import { request } from './client';

export type FundCalendarReply = 'accepted' | 'tentative' | 'declined' | 'pending';
export type FundCalendarMember = { email: string; name: string;
  calendar: 'connected' | 'not_connected' | 'unavailable' };
export type FundCalendarNote = { note_id: string; counterparty_id: string; title: string; body: string;
  author_email: string; created_at: string; updated_at: string };
export type FundCalendarInvestor = {
  counterparty_id: string; display_name: string; institution_id: string | null;
  institution_name: string; stage: string | null; response: FundCalendarReply;
  call_brief?: { content: string; generated_at: string; prepared_for: string;
    sources: Array<{ id: string; label: string; kind: string }> };
  call_brief_status?: 'generating' | 'failed' | 'ready';
};
export type FundCalendarMeeting = { id: string; summary: string; start: string; end: string;
  lead: string; team: string[]; investors: FundCalendarInvestor[]; notes: FundCalendarNote[] };
export type FundCalendar = { viewer: string; members: FundCalendarMember[]; meetings: FundCalendarMeeting[] };

export type FundCalendarIndexMeeting = Pick<FundCalendarMeeting, 'id' | 'summary' | 'start' | 'end' | 'lead' | 'team'>
  & { investors: Pick<FundCalendarInvestor, 'counterparty_id' | 'display_name' | 'institution_name'>[] };
export type FundCalendarIndex = { viewer: string; members: FundCalendarMember[]; meetings: FundCalendarIndexMeeting[] };

const range = (start: string, end: string) => `start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}`;

/** Every teammate's meetings with confirmed LPs in [start, end), at most eight days. */
export const getFundCalendar = (start: string, end: string) =>
  request<FundCalendar>(`/fund/calendar?${range(start, end)}`);

/** The same meetings over at most 26 weeks, names only, for searching across weeks. */
export const getFundCalendarIndex = (start: string, end: string) =>
  request<FundCalendarIndex>(`/fund/calendar/index?${range(start, end)}`);
